/**
 * eİcraPro kimliği imzacıya devredildi mi ("eİcraPro ile bağlantı sağlandı mı").
 *
 * Kimliği tarayıcıdaki eİcraPro yazar: `setApiCookiesToImza()` Electron
 * proxy'sinin `/setConfig` ucuna token + tenant + tckn + apiType gönderir; proxy
 * bunları bu pencerenin sessionStorage'ına yazar ve API hedefini (proxyTarget)
 * aynı çağrıda belirler, ardından socket'e `updateToken` yayınlanır. Devir
 * olmadan imzacı:
 *  - API'ye istek ATMAMALI: proxy'nin API hedefi boştur ("Host should not be
 *    empty", DEV-2603 9 Eki yorumu), hedef dolu olsa bile Authorization ve
 *    Tenant-Id yoktur;
 *  - UYAP'a GİRMEMELİ: hesap TCKN'si bilinmediği için hesap-kart kimlik
 *    denetimi atlanır ve oturum kime ait olduğu bilinmeden açılır.
 *
 * Şart: token ve tenant_id dolu (Laravel TenantValidationMiddleware tenant_id
 * başlığı olmadan 401 döner). TCKN şart DEĞİL: `users.kimlik_no` boş olabilir,
 * TCKN'siz hesapta bugünkü davranış korunur. eİcraPro'nun store'u boşken
 * gönderdiği "Bearer undefined" gibi değerler devir sayılmaz.
 *
 * Saf tutuldu (depo dışarıdan verilir) ki test edilebilsin. Vuex getter'ı
 * içinde ÇAĞRILMAMALI: sessionStorage reaktif değildir, getter ilk değerde
 * donar. Sonucu store'daki `tokenDurumunuYenile` mutation'ı state'e taşır.
 */
export function eicraproKimligiVarMi(depo: Pick<Storage, 'getItem'> | null | undefined): boolean {
    if (!depo) {
        return false;
    }
    let token: string | null;
    let tenantId: string | null;
    try {
        token = depo.getItem('accessToken');
        tenantId = depo.getItem('tenant_id');
    } catch (e) {
        return false;
    }
    const tokenGovdesi = String(token ?? '').trim().replace(/^Bearer\s*/i, '');
    return doluMu(tokenGovdesi) && doluMu(String(tenantId ?? '').trim());
}

function doluMu(deger: string): boolean {
    return deger !== '' && deger !== 'undefined' && deger !== 'null';
}

/**
 * Kimlik gelmeden UYAP girişi istendiğinde `connectToUyap`'ın fırlattığı hatanın
 * metni. Çağıranlar bu hatayı "başarısız giriş" değil "bekleme" olarak tanır.
 */
export const EICRAPRO_BEKLENIYOR_MESAJI =
    "eİcraPro bağlantısı bekleniyor. Tarayıcıdan eİcraPro'ya giriş yaptığınızda UYAP bağlantısı kendiliğinden kurulur.";

export function eicraproBekleniyorHatasiMi(hata: unknown): boolean {
    return (hata as { message?: unknown } | null | undefined)?.message === EICRAPRO_BEKLENIYOR_MESAJI;
}
